"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_busCertificate = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `BusCertificate`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.snakeCase(friendlyName)}_${suggestedSerialNumber}`,
        },
    };
    if (nodeToCopy) {
        nodeData.configuration = (0, utils_1.copyNodeConfiguration)({
            nodeToCopy,
            isNode,
            nodeType: types_1.nodeType,
            suggestedSerialNumber,
        });
    }
    return nodeData;
};
/*
 * Validate the node wrt the rest of the graph. busCertificate is the
 * terminal certificate trigger: it takes exactly one reconciled-bus-tape as its
 * input and has no outputs. (In the committed/UI graph its input is the
 * reconciled-bus-tape directly; the approval-gate `userInputNeeded` node is
 * synthetic and only interposed at DB-attach time.)
 */
const hasValidConfig = ({ node, friendlyName, inputs, outputs, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_reconciledBusTape',
    ];
    return (0, utils_1.checkEdges)({
        friendlyName,
        inputs,
        outputs,
        isAllowedInputNode: (uiNode) => allowedInputNodes.some((type) => type === uiNode.nodeType),
        minInputs: 1,
        maxInputs: 1,
        minOutputs: 0,
        maxOutputs: 0,
    });
};
/**
 * Terminal trigger node that fires the Backup Servicing Certificate reporting
 * worklease once the reconcile approval gate is accepted. It produces no tape.
 */
exports.file_busCertificate = {
    nodeTypeText: 'BUS certificate',
    nodeType: types_1.nodeType,
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    badgeTexts: ['BackupServicing'],
    createNewNode,
    isNode,
    isIntermediateRecord,
    ...otherProps,
    hasValidConfig,
    // no generated-tape validation: this node carries no config + writes no tape.
    validateIntermediateTape: () => [],
};
//# sourceMappingURL=uinode.js.map